<div class="payment-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="header-title">Payment Terms and Conditions </span>

    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <iframe [src]="pdfUrl" name="myIframe" class="w-100 h-100"></iframe>
  </div>
</div>
